import moment from 'moment';
import parseFormat from 'moment-parseformat';

// Function to parse date string in various formats and convert to yyyy-mm-dd
export const dateFormatConverter = (dateString) => {
  if (!dateString) {
    return null;
  }
  // Automatically detect the date format
  const formatString = parseFormat(dateString);

  // Parse the date with the detected format
  const parsedDate = moment(dateString, formatString);

  if (!parsedDate.isValid()) {
    return null;
  }

  // Format the parsed date to yyyy-mm-dd
  return parsedDate.format('YYYY-MM-DD');
};

export const isValidDate = (dateString) => {
  if (!dateString) {
    return null;
  }
  // Automatically detect the date format
  const formatString = parseFormat(dateString);

  // Parse the date with the detected format
  const parsedDate = moment(dateString, formatString);

  if (parsedDate.isValid()) {
    return true;
  }
};
